//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { v4 as uuidv4 } from 'uuid'
import TopScreen from '~/components/TopScreen.vue'
import FooterTop from '~/components/footer/footerTop.vue'
import APIloading from '~/components/common/APILoading.vue'
import APIFailed from '~/components/common/APIFailed.vue'
import { esaDecryptData } from '~/plugins/secret'

export default {
  components: {
    TopScreen,
    FooterTop,
    APIloading,
    APIFailed
  },
  data () {
    return {
      category: this.$i18n.t('careers.block1.field1'),
      catList: this.categories,
      careers: [],
      fetched: false,
      fetchError: false
    }
  },
  async fetch () {
    if (!this.$encrypt) {
      return
    }
    try {
      const uuid = uuidv4().replace(/-/g, '')
      const response = await fetch(
        `${process.env.APIURL}/website/common/job/list`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            key: this.$encrypt(uuid)
          })
        }
      )
        .then(res => res.json())
        .catch(function (e) {})
      const { data, key } = response
      if (data && key) {
        const preResult = esaDecryptData(data, this.$decrypt(key))
        const careers = JSON.parse(preResult)
        // eslint-disable-next-line no-console
        // console.log('careers ========> ', careers)
        if (careers.length) {
          const openCareers = careers.filter((carr) => {
            const jobOnline = carr.jobs.filter(
              job =>
                Number(job.status) === 1 && Number(job.logical_status) === 1
            )
            if (jobOnline.length > 0) {
              carr.jobs = jobOnline
            }
            return Number(carr.status) === 1 && jobOnline.length > 0
          })
          if (openCareers.length) {
            this.careers = openCareers
            // console.log('this.careers ========> ', this.careers)
            return
          }
        }
        this.fetched = true
        this.careers = []
      }
    } catch (err) {
      // console.log('err', err)
      this.careers = []
      this.fetched = true
      // this.fetchError = true
    }
  },
  head () {
    return {
      title: this.$t('footer.about.careers').concat(' | Pagsmile '),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('seo.description')
        }
      ]
    }
  },
  // fetchOnServer: false,
  computed: {
    categories () {
      if (this.careers && this.careers.length) {
        const careerList = [
          {
            specialty_id: 'none',
            specialty_name: this.$i18n.t('careers.block1.field1')
          },
          ...this.careers
        ]
        return Object.values(
          careerList.reduce(
            (acc, cur) => Object.assign(acc, { [cur.specialty_name]: cur }),
            {}
          )
        )
      } else {
        return []
      }
    },
    sortedItems () {
      if (this.categories.length) {
        const x = {}
        let categories
        if (this.category === this.$i18n.t('careers.block1.field1')) {
          categories = this.categories.filter(
            cat => cat.specialty_id !== 'none'
          )
        } else {
          categories = this.categories.filter(
            cat => cat.specialty_name === this.category
          )
        }
        categories.forEach((item, index) => {
          /* console.log('category', item.category)
          console.log('filter', this.careers.filter(position => position.category === item.category)) */
          x[index] = {
            category: item.specialty_name,
            items: this.careers.filter(
              position => position.specialty_name === item.specialty_name
            )
          }
          return x
        })
        /* console.log('sItems', x) */
        return x
      } else {
        return []
      }
    }
  },
  mounted () {
    this.clientFetch()
  },
  methods: {
    clientFetch () {
      this.$fetch()
    }
  }
}
